import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill="#FAE1E1" d="M4.5 15.008h2.627v3.483H4.5z"/> <path fill="#FAE1E1" fill-rule="evenodd" d="M10.919 11.842H8.624v6.65h2.627v-6.318l-.332-.332zM12.749 13.672v4.82h2.627v-2.193l-2.627-2.627zm2.627.505V8.675h-2.627v2.876l2.627 2.627zM16.873 17.797v.695h.696l-.696-.695zm2.627.505V5.508h-2.627v10.167l2.627 2.627z" clip-rule="evenodd"/> <path fill="#BD3D3A" fill-rule="evenodd" d="M4.49 6.45a.734.734 0 011.038 0l14.284 14.283a.734.734 0 01-1.038 1.038L4.49 7.487a.734.734 0 010-1.038z" clip-rule="evenodd"/>' }
  })
);